module.exports = __webpack_public_path__ + "80fb15f202d38f093a4e89d2a0d083b8.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/images/paywalls/cloze-category-and-passage.gif
// module id = 558
// module chunks = 0